import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, Router, ActivatedRouteSnapshot, RouterStateSnapshot, Route, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../auth.service';

@Injectable()
export class RoleGuard implements CanActivate, CanActivateChild, CanLoad {

    constructor(private authService: AuthService, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.isInRole(route, state.url);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.canActivate(route, state);
    }

    canLoad(route: Route): Observable<boolean | UrlTree> {
        const roles = route.data?.roles as string[];

        if (!roles || roles.length === 0) {
            return of(true);
        }

        return this.authService.queryCurrentUser().pipe(
            map(user => {
                // Not logged in
                if (!user) {
                    return this.router.createUrlTree(['/auth/login']);
                }

                // Role check
                const allowed = roles.some(role =>
                    this.authService.isInRole(user, role)
                );

                return allowed
                    ? true
                    : this.router.createUrlTree(['/dashboard']);
            }),
            catchError(error => {
                console.error('RoleGuard canLoad Error:', error);
                this.authService.logout?.();
                return of(this.router.createUrlTree(['/auth/login']));
            })
        );
    }

    isInRole(
        route: ActivatedRouteSnapshot,
        url: string
    ): Observable<boolean | UrlTree> {

        if (!route.data || !route.data.roles) {
            return of(true);
        }

        const requiredRoles: string[] = route.data.roles;

        return this.authService.queryCurrentUser().pipe(
            map(user => {
                if (!user) {
                    this.authService.redirectUrl = url;
                    return this.router.createUrlTree(['/auth/login']);
                }

                // Check role
                const allowed = requiredRoles.some(role =>
                    this.authService.isInRole(user, role)
                );

                return allowed
                    ? true
                    : this.router.createUrlTree(['/dashboard']);
            }),
            catchError(error => {
                console.error('RoleGuard isInRole Error:', error);
                this.authService.logout?.();
                return of(this.router.createUrlTree(['/auth/login']));
            })
        );
    }
}
